import { timerActions } from "../../../store/timerSlice"
import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"

export const GetMatterDependencyDataMutation = <T>(
    emails:Array<string> = [],
    callbacks?: Callbacks<T>,
) => {
    const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks)

    const { getRequest, postRequest } = useHttpRequest({})
    return async (dispatch: any) => {
        const getMatters = async () => {
            try {
                const response = await postRequest(`${UrlConstant.MatterDependency}/${UrlConstant?.GetActiveRecordByFilter}`,emails)
                const data = await response
                return data?.data
            }
            catch (error) {
                onError(error as Error)
            }
        }
        
        try {
            const matters = await getMatters()
            dispatch(timerActions.getMatterDependencyData({matters}))

        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
// export const GetDependencyDataMutation = <T>(
//     locationId:string,
//     callbacks?: Callbacks<T>,
// ) => {
//     const { onError, onLoading } = useCallBack<T>(callbacks)
//     const { getRequest } = useHttpRequest({})

//     return async (dispatch: any) => {
//         onLoading(true)
//         const [
//             getMatters,
//             getUsers,
//             getTaskCodes,
//             getExpenseCodes,
//             getTimeEntryCategories,
//             getExpenseCategories,
//             getUtbmsGroups,
//             getTaxes,
//         ] = await useDependency([
//             getRequest(`${UrlConstant.MatterDependency}/${UrlConstant.GetAllActiveRecord}`),
//             getRequest(`${UrlConstant.UserDependency}/${UrlConstant.GetAllActiveRecord}?locationId=${locationId}`),
//             getRequest(`${UrlConstant.UTBMSCode}/${UrlConstant.GetAllActiveRecord}?type=3`),
//             getRequest(`${UrlConstant.UTBMSCode}/${UrlConstant.GetAllActiveRecord}?type=2`),
//             getRequest(`${UrlConstant.ActivityCategory}/${UrlConstant.GetAllActiveRecord}`),
//             getRequest(`${UrlConstant.ExpenseCategory}/${UrlConstant.GetAllActiveRecord}`),
//             getRequest(`${UrlConstant.UTBMSDefaultGroup}/${UrlConstant.GetAllActiveRecords}`),
//             getRequest(`${UrlConstant.Tax}/${UrlConstant.GetAllActiveRecord}`),
//         ])
//         try {
            // const matters = getMatters.data ? getMatters.data : []
            // const users = getUsers.data ? getUsers.data : []
            // const taskCodes = getTaskCodes.data ? getTaskCodes.data : []
            // const timeEntryCategories = getTimeEntryCategories.data
            //     ? getTimeEntryCategories.data
            //     : []
            // const expenseCodes = getExpenseCodes.data ? getExpenseCodes.data : []
            // const expenseCategories = getExpenseCategories.data ? getExpenseCategories.data : []
            // const isEnableUtbms = getUtbmsGroups.data ? getUtbmsGroups.data : []
            // const taxes = getTaxes.data ? getTaxes.data : []

//             dispatch(
//                 timerActions.getDependencyData({
//                     matters,
//                     users,
//                     taskCodes,
//                     timeEntryCategories,
//                     isEnableUtbms,
//                     expenseCodes,
//                     expenseCategories,
//                     taxes,
//                 })
//             )
//         } catch (error) {
//             onError(error as Error)
//         } finally {
//             onLoading(false)
//         }
//     }
// }
